import { Component, OnInit, EventEmitter, Inject, ChangeDetectionStrategy } from '@angular/core';
import { Location} from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../../services/general.service';
import { ProvidersService } from '../../../services/providers.service';
import { UsersService } from '../../../services/users.service';
import { ProviderDetailComponent } from '../provider-detail/provider-detail.component';
import * as decode from 'jwt-decode';

@Component({
  selector: 'app-provider',
  templateUrl: './provider.component.html',
  styleUrls: ['./provider.component.scss']
})
export class ProviderComponent implements OnInit {
  userId: any;
  userToken: any;
  editId: any;
  load = false;
  datanew: any = {};
  dataAddress: any = {};
  dataProvider: any = {};
  typeFileUpload = '';
  loadBtn = false;
  editing = {};

  //constructor(private toastr: ToastrService, public dialog: MatDialog, private gralService: GeneralService, private provService: ProvidersService, public location: Location, private router: Router, private route: ActivatedRoute, private usersService: UsersService) {
  constructor(private toastr: ToastrService, private gralService: GeneralService, private provService: ProvidersService, public dialogRef: MatDialogRef<ProviderComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {

    //this.route.params.subscribe(params => {
    //  this.editId = params['id'];
    //});

    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);
    this.userId = tokenPayload.Id;
    this.editId = this.data.provider;

    if(this.editId){
      gralService.changeTextHead('EDITPROVIDERS');
      this.getProvider();
    }else{
      gralService.changeTextHead('ADDPROVIDERS');
    }
  }

  ngOnInit() {
  }

  getProvider(){
    this.load = true;
    this.provService.getProvider(this.editId, this.userToken).then((data) => {
      if(data['EsValido']){
        this.dataProvider = data['Entidad'].Proveedor;
        this.dataAddress = data['Entidad'].Direccion;
      }else{
        this.toastr.error(data['MensajeUsuario'], 'Error al cargar proveedor');
        //this.location.back();
      }
      this.load = false;
    }, (err) => {
      console.log(err);
      this.load = false;
      this.toastr.error(err['error'].msg, 'Error al cargar proveedor');
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  getcp(ev){
    console.log(ev)
    if(ev.target.value.length == 5){
      this.gralService.getPostalCode(ev.target.value).then((data) => {
        this.dataAddress.Estado = data['estado'];
        this.dataAddress.Ciudad = data['municipio'];
      }, (err) => {
        console.warn(err);
      });
    }
  }

  save(){
    if(!this.validation()){
      return false;
    }

    this.loadBtn = true;

    if(this.editId){
      let params = {
                    id: this.editId,
                    "Proveedor": {
                        "Nombre": this.dataProvider.Nombre,
                        "RFC": this.dataProvider.RFC,
                        "Email": this.dataProvider.Email,
                    },
                    "Direccion":
                    {              
                        "CP": this.dataAddress.CP 
                    }
      };
      this.provService.updateDataProvider( params ,this.userToken).then((res:any)=>{
        if(res.EsValido){
          this.toastr.success('Datos actualizados correctamente', 'Datos actualizados');
          this.dialogRef.close();

        }else{
          //this.toastr.error('No se pudo actualizar la información en este momento, intentalo más tarde', 'Error de actualización');
          this.toastr.error(res['MensajeUsuario'], 'Error al actualizad Proveedor');
          return false;  
        }
      })
    }else{
      this.dataProvider.RFC = this.dataProvider.RFC.toUpperCase();
      this.dataProvider.Nombre = this.dataProvider.Nombre.toUpperCase();
      this.dataProvider.Activo = true;
      this.datanew = {Proveedor: this.dataProvider, Direccion: this.dataAddress};
      this.provService.newProvider(this.datanew, this.userToken).then((data) => {
        this.loadBtn = false;
        this.toastr.success('Proveedor agregado correctamente', 'Agregar proveedor');
        this.dialogRef.close();

        //this.location.back();
      }, (err) => {
        this.loadBtn = false;
        console.log(err);
        this.toastr.error(err['error'].msg, 'Agregar proveedor');
        if(err.status == 401){
          this.gralService.actDeacUser(false);
        }
      });
    }
  }

  validation(){
    // if(!this.dataProvider.Nombre || !this.dataProvider.RFC || !this.dataAddress.Pais || !this.dataAddress.CP || !this.dataAddress.Estado || !this.dataAddress.Ciudad || !this.dataAddress.Direccion1 || !this.dataAddress.Direccion2){
    //   this.toastr.error('Favor de llenar todos los datos obligatorios', 'Error al crear proveedor');
    //   return false;
    // }
    if(!this.dataProvider.Nombre || !this.dataProvider.RFC || !this.dataAddress.CP || !this.dataProvider.Email){
      this.toastr.error('Favor de llenar todos los datos obligatorios', 'Error al crear proveedor');
      return false;
    }

    return true;
  }

  onCloseCancel() {
    this.dialogRef.close();
  }

  onCloseConfirm() {
    this.dialogRef.close({ data: true });
  }

}
